/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { State } from '@core/store';
import { Store } from '@ngrx/store';
import { Tour } from '@shared/models';
import { WorkflowAction } from '@shared/models/workflow-action';
import { ObjectIdPipe } from '@shared/pipes/object-id.pipe';
import { TourStateDefinition } from '@tours/models/tour-state-definition';
import { NumericStatePipe } from '@tours/pipes/numeric-state.pipe';
import { TourStatesService } from '@tours/services/tour-states.service';
import { LoadTours, TourWorkflowAction } from '@tours/store/tours.actions';

@Component({
    selector: 'app-tour-item-menu',
    templateUrl: './tour-item-menu.component.html',
    styleUrls: ['./tour-item-menu.component.scss'],
    standalone: false
})
export class TourItemMenuComponent implements OnInit {
  @Input() tour: Tour;

  undoTransitionAction?: WorkflowAction;
  private tourStates: TourStateDefinition[];

  constructor(
    private store: Store<State>,
    private tourStatesService: TourStatesService,
    private numericStatePipe: NumericStatePipe,
    private router: Router,
    private objectIdPipe: ObjectIdPipe,
  ) { }

  ngOnInit(): void {
    this.tourStates = this.tourStatesService.getStateDefinitions();
    this.undoTransitionAction = this.tour.potentialAction.filter(
      action => action.name.startsWith('undo') && !action.error
    ).shift();
  }

  executeWorkflowAction(action: WorkflowAction): void {
    this.store.dispatch(new TourWorkflowAction(action));
  }

  getTargetState(name: string): TourStateDefinition {
    if (name === 'skip_delivery_note') {
      return this.tourStates[this.tourStates.length - 2];
    }
    return this.tourStates[this.numericStatePipe.transform(this.tour.state)];
  }

  print(tour: Tour): void {
    const tree = this.router.createUrlTree(['/tours', this.objectIdPipe.transform(tour), 'notes']);
    const url = this.router.serializeUrl(tree);

    const childWindow = window.open(url, '_blank');

    if (!childWindow) {
      return;
    }

    const timer = window.setInterval(() => {
      if (childWindow.closed) {
        window.clearInterval(timer);
        this.store.dispatch(new LoadTours());
      }
    }, 500);
  }
}
